import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'dateTimeCompletedPipe',
})
export class DateTimeCompletedPipe implements PipeTransform {
    transform(value: string): string {
        if (!value) return value;

        const date = new Date(value);
        const day = String(date.getUTCDate()).padStart(2, '0');
        const month = String(date.getUTCMonth() + 1).padStart(2, '0');
        const year = date.getUTCFullYear();
        const hours = String(date.getUTCHours()).padStart(2, '0');
        const minutes = String(date.getUTCMinutes()).padStart(2, '0');
        const seconds = '00';

        return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
    }
}
